import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "moment-duration-format";

//import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { getGlobalClasses } from "../../themes";

//containers
import AuthUserContainer from "../../containers/AuthUser";
import TimeClockPermissionContainer from "../../containers/TimeClock/TimeClockPermission";

//- UI / Form
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
//import DownloadIcon from '@material-ui/icons/CloudDownload';
import SearchIcon from "@material-ui/icons/Search";

import FormDatePicker from "../../components/form/FormDatePicker";
import UserPicker from "../../components/advancedForm/UserPicker";
import FormComponent from "../../components/FormComponent";
import TimeClockContainer from "../../containers/TimeClock/TimeClock";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import TimeClockLocationSelect from "../../components/advancedForm/TimeClockLocationSelect";
import FormCheckbox from "../../components/form/FormCheckbox";
import localStorage from "../../libs/localStorage";
import ShiftTable from "./ShiftTable";
import SectionHeader from "../../components/SectionHeader";

const styles = (theme) => {
  return {
    ...getGlobalClasses(theme),
    submitButton: {
      marginTop: 20,
      fontSize: 16,
      borderRadius: "100px",
      padding: "13px 45px",
      textTransform: "uppercase",
      marginRight: 10,
    },
    icon: {
      paddingRight: 5,
    },
    oddRow: {
      backgroundColor: "#f9f9f9",
    },
    resultsHere: {
      padding: 30,
      backgroundColor: "#f1f1f1",
      color: "#777",
      borderRadius: 10,
    },
    runningSearch: {
      paddingLeft: 20,
      display: "flex",
      alignItems: "center",
      fontSize: 18,
      color: "#666",
    },
    button: {
      marginRight: 5,
    },
    eventsContainer: {
      padding: 20,
    },
    eventContainer: {
      borderTop: "1px solid #eee",
      marginTop: 5,
      paddingTop: 5,
    },
    eventNote: {},
    eventDateTime: {
      fontSize: "80%",
      color: "#666",
    },
    removeButton: {
      verticalAlign: "middle",
      padding: "8px 10px",
    },
  };
};

function storeKey(key) {
  return `/shiftReports-${key}`;
}

class ShiftReports extends FormComponent {
  constructor(props) {
    super(props);

    let includeHidden =
      localStorage.getItem(storeKey("includeHidden")) || false;
    let includeOpenShifts =
      localStorage.getItem(storeKey("includeOpenShifts")) || false;

    let includeCopyPasteColumn =
      localStorage.getItem(storeKey("includeCopyPasteColumn")) || false;
    let includeExportedColumn =
      localStorage.getItem(storeKey("includeExportedColumn")) || false;

    let showDrivers = localStorage.getItem(storeKey("showDrivers")) || false;
    let showNonDrivers =
      localStorage.getItem(storeKey("showNonDrivers")) || false;

    let includeTermUsers =
      localStorage.getItem(storeKey("includeTermUsers")) || false;

    this.state = {
      afterDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      beforeDate: moment().format("YYYY-MM-DD"),

      order: "asc",
      orderBy: "clockInDateTime",
      isSearching: false,
      isClockOutEmployeeDialogOpen: false,
      isUpdateEmployeeDialogOpen: false,
      timeClockShiftForClockOut: undefined,
      isRemoveShiftDialogOpen: false,
      timeClockShiftForRemove: undefined,
      includeHidden,
      includeOpenShifts,
      includeCopyPasteColumn,
      includeExportedColumn,
      showDrivers,
      showNonDrivers,
      includeTermUsers,
      refreshId: 1,
    };
  }

  componentDidMount() {
    if (_.isUndefined(this.props.myTimeClockPermissions)) {
      this.props.getMyTimeClockPermissions();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.includeHidden !== prevState.includeHidden) {
      localStorage.setItem(storeKey("includeHidden"), this.state.includeHidden);
    }
    if (this.state.includeOpenShifts !== prevState.includeOpenShifts) {
      localStorage.setItem(
        storeKey("includeOpenShifts"),
        this.state.includeOpenShifts
      );
    }

    if (
      this.state.includeCopyPasteColumn !== prevState.includeCopyPasteColumn
    ) {
      localStorage.setItem(
        storeKey("includeCopyPasteColumn"),
        this.state.includeCopyPasteColumn
      );
    }

    if (this.state.includeExportedColumn !== prevState.includeExportedColumn) {
      localStorage.setItem(
        storeKey("includeExportedColumn"),
        this.state.includeExportedColumn
      );
    }

    if (this.state.showDrivers !== prevState.showDrivers) {
      localStorage.setItem(storeKey("showDrivers"), this.state.showDrivers);
    }

    if (this.state.showNonDrivers !== prevState.showNonDrivers) {
      localStorage.setItem(
        storeKey("showNonDrivers"),
        this.state.showNonDrivers
      );
    }

    if (this.state.includeTermUsers !== prevState.includeTermUsers) {
      localStorage.setItem(
        storeKey("includeTermUsers"),
        this.state.includeTermUsers
      );
    }
  }

  getApiParams = () => {
    const { accessToken } = this.props;
    const {
      shiftForUserIds,
      timeClockLocationId,
      afterDate,
      beforeDate,
      includeHidden,
      includeOpenShifts,
      showDrivers,
      showNonDrivers,
    } = this.state;

    const afterDateTime = moment(afterDate)
      .startOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    const beforeDateTime = moment(beforeDate)
      .endOf("day")
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    let shiftForUserRole = undefined;
    if (showDrivers && showNonDrivers) {
      shiftForUserRole = undefined;
    } else if (showDrivers) {
      shiftForUserRole = "driver";
    } else if (showNonDrivers) {
      shiftForUserRole = "nonDriver";
    }

    const params = {
      accessToken,
      shiftForUserIds,
      afterDateTime,
      beforeDateTime,
      includeHidden,
      includeOpenShifts,
      shiftForUserRole,
    };

    if (timeClockLocationId) {
      params.timeClockLocationIds = [timeClockLocationId];
    }

    return params;
  };

  handleSearch = () => {
    const { showErrors } = this.props;

    const formFieldError = {};
    _.values(this.requiredPathMap).forEach(({ path, label }) => {
      if (!this.state[path]) {
        formFieldError[path] = `${label} is required`;
      }
    });
    if (_.keys(formFieldError).length) {
      this.setState({ formFieldError });
      return showErrors(_.values(formFieldError));
    }

    this.setState({
      isSearching: true,
      hasResults: true,
      refreshId: this.state.refreshId + 1,
      auditSearchIsPaused: false,
    });
  };

  onDataCallback = (rows) => {
    this.setState({
      isSearching: false,
    });
  };

  render() {
    const {
      classes,
      permissions,
      //myTimeClockPermissions,
      //myCanViewUserIds,
      myCanModifyUserIds,
    } = this.props;

    const {
      showDrivers,
      showNonDrivers,
      includeTermUsers,
      hasResults,
    } = this.state;

    if (!permissions || !_.includes(permissions, "canViewTimeClocks")) {
      return <div>You do not have valid permissions to view this page.</div>;
    }

    const params = this.getApiParams();
    params.downloadCsv = true;
    const request = {
      method: "timeClockShift.manager.search",
      params,
    };
    const downloadUrl = `/api?request=${JSON.stringify(request)}`;

    let whoToShow = "all";
    if (showDrivers && showNonDrivers) {
      whoToShow = "all";
    } else if (showDrivers) {
      whoToShow = "driversOnly";
    } else if (showNonDrivers) {
      whoToShow = "nonDriversOnly";
    }

    const isRequired = true;
    return (
      <form>
        <div className={classes.globalMainHeadline}>Time Clock Reports</div>
        <Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
          <Grid spacing={2} container>
            <Grid item xs={12} sm={11} md={6}>
              <Grid spacing={2} container>
                <SectionHeader
                  label="Search Filters"
                  gridProps={{ md: 12 }}
                  isTop={true}
                />
                <UserPicker
                  {...this.setForm("shiftForUserIds", "Employees")}
                  helpText={"Only showing employees you have permission for"}
                  userIdsToShow={myCanModifyUserIds}
                  selectMultiple={true}
                  whoToShow={whoToShow}
                  includeTermUsers={includeTermUsers}
                  includeHidden={true}
                />

                <FormCheckbox
                  {...this.setForm("showDrivers", "Drivers", false, false)}
                  gridProps={{ md: 3 }}
                />

                <FormCheckbox
                  {...this.setForm(
                    "showNonDrivers",
                    "Non-Drivers",
                    false,
                    false
                  )}
                  gridProps={{ md: 3 }}
                />

                <FormCheckbox
                  {...this.setForm(
                    "includeTermUsers",
                    "Show Term Users",
                    false,
                    false
                  )}
                  gridProps={{ md: 3 }}
                />

                <TimeClockLocationSelect
                  {...this.setForm("timeClockLocationId", "Location")}
                />

                <FormDatePicker
                  {...this.setForm(
                    "afterDate",
                    "Clocked In After This Date",
                    isRequired
                  )}
                  format={"M/D/YYYY"}
                />

                <FormDatePicker
                  {...this.setForm(
                    "beforeDate",
                    "Clocked In Before This Date",
                    isRequired
                  )}
                  format={"M/D/YYYY"}
                />

                <FormCheckbox
                  {...this.setForm(
                    "includeOpenShifts",
                    "Include Open Shifts",
                    false,
                    false
                  )}
                />

                <FormCheckbox
                  {...this.setForm(
                    "includeHidden",
                    "Include Deleted Shifts",
                    false,
                    false
                  )}
                />

                <Grid item xs={12} style={{ padding: "20px 0px" }}>
                  <Button
                    onClick={this.handleSearch}
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                  >
                    <SearchIcon className={classes.icon} />
                    Search
                  </Button>

                  <a
                    href={downloadUrl}
                    style={{ textDecoration: "none", paddingRight: 5 }}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                    >
                      <DownloadIcon className={classes.icon} />
                      Search & Download Report
                    </Button>
                  </a>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={1}></Grid>
            <Grid item xs={12} md={5}>
              <SectionHeader
                label="Columns To Display"
                gridProps={{ md: 12 }}
                isTop={true}
              />

              <div style={{ marginTop: 12 }}></div>
              <FormCheckbox
                {...this.setForm(
                  "includeCopyPasteColumn",
                  "Include Copy/Paste Column",
                  false,
                  false
                )}
              />

              <FormCheckbox
                {...this.setForm(
                  "includeExportedColumn",
                  "Include Exported Column",
                  false,
                  false
                )}
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper className={classes.globalMainPaper}>
          {!hasResults && (
            <div className={classes.resultsHere}>Results here</div>
          )}
          {hasResults && this.renderResults()}
        </Paper>
      </form>
    );
  }

  handleSort = (orderBy) => {
    let order = "desc";
    if (this.state.orderBy === orderBy && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order: order, orderBy: orderBy });
  };

  renderResults = () => {
    const params = this.getApiParams();
    return (
      <ShiftTable
        method="timeClockShift.manager.search"
        params={params}
        paused={this.state.auditSearchIsPaused}
        refreshId={this.state.refreshId}
        onDataCallback={this.onDataCallback}
        includeCopyPasteColumn={this.state.includeCopyPasteColumn}
        includeExportedColumn={this.state.includeExportedColumn}
      />
    );
  };
}

ShiftReports.propTypes = {
  timeClockShiftManagerSearch: PropTypes.func.isRequired,
  userMap: PropTypes.object,

  showErrors: PropTypes.func.isRequired,
  authUser: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default _.flow([
  withStyles(styles),
  AuthUserContainer,
  TimeClockContainer,
  TimeClockPermissionContainer,
])(ShiftReports);
